import { roundnessCalculator } from '@/components/DesignSystem/AtomicComponents/util';
import { useSelector } from '@/redux/reducers';
import { deviceWidth } from '@/utils/deviceWidth';
import { handleB2bCart } from '@/utils/handleB2bCart';
import { MAX_MOBILE_WIDTH } from '@/utils/constants';
import { useDispatch } from 'react-redux';
import styles from './B2b.module.scss';
import { getB2bRequestQuote } from './utils/util';

export const B2bRequestForQuoteMobile = ({
  storeInfo,
  openRfqFormModal,
  product,
  toggleAuthModal,
  activeVariant,
}) => {
  const dispatch = useDispatch();
  const isMobile = deviceWidth <= MAX_MOBILE_WIDTH;
  const { userData } = useSelector((state) => ({
    userData: state.userReducer,
  }));

  const handleRequestForBtnClick = () => {
    if (!userData?.isLogin) {
      toggleAuthModal();
      return;
    } else {
      handleB2bCart(
        product,
        activeVariant,
        'ADD',
        activeVariant
          ? activeVariant?.b2b_pricing_info?.minimum_order_quantity
          : product?.b2b_pricing_info?.minimum_order_quantity
      );
      dispatch(openRfqFormModal());
    }
  };

  if (!isMobile) return null;

  return (
    <div className={styles.b2bRequestForQuoteMobileBtn}>
      <button
        onClick={handleRequestForBtnClick}
        className={styles.btn}
        style={{
          backgroundColor: storeInfo?.theme?.colors?.primary_color,
          borderRadius: roundnessCalculator(storeInfo?.theme?.roundness),
        }}
      >
        {getB2bRequestQuote(storeInfo?.store_id)}
      </button>
    </div>
  );
};
